import axios from 'axios';
import store from '@/store'
import router from "@/router";
import {MessageBox, Message} from "element-ui";

const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API, // url = base url + request url
  // withCredentials: true, // 如跨域请求时要带上cookies,则设置为true
  timeout: 300000, // 请求超时时长
});

service.interceptors.request.use(
  (config: any) => {
    // 在发送请求之前做些什么
    return config;
  },
  (error: any) => {
    console.log(error);
    store.commit('SET_LOADING', false);
    return Promise.reject(error);
  },
);

service.interceptors.response.use(
  (response) => {
    store.commit('SET_LOADING', false);
    // 如果返回的状态不是200 就报错 按需修改
    if (response.status && response.status !== 200) {
      return Promise.reject(new Error('Error'));
    }
    return response;
  },
  (error) => {
    store.commit('SET_LOADING', false);
    if(error.response) {
      console.log(error.response)
      if(error.response.status === 400) {
        Message.error(error.response.data.message|| error.response.data.result);
        return Promise.reject(error);
      } else if(error.response.status === 401) {
        // 如果返回401 即没有权限，跳到登录页重新登录
        store.commit('SET_LOADING_MESSAGE', '');
        store.commit('SET_HARD_LOADING', false);
        MessageBox.alert('登录失效，请重新登录')
        router.replace({
          path: '/login',
          query: {redirect: router.currentRoute.fullPath}
        })
        return Promise.reject(error);
      } else if (error.response.status === 403) {
        Message.error('账号没有操作权限')
        return Promise.reject(error);
      }
    }
    Message.error('网络请求失败，清稍后重试')
    return Promise.reject(error);
  },
);

export default service;
